export default __webpack_public_path__ + "images/models/c5a12d298604e74f8ade237ba91071f6.glb";